import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

import FeatureSection from "../shared/FeatureSection";
import QuickLinksSection from "./QuickLinksSection";
import {BackToProductsButton} from "../layout/BackButton";

// Updated Hardware Products page with back button
function HardwareProductsPage({ handleNavClick }) {
  return (
    <div className="product-detail-page">
      <BackToProductsButton handleNavClick={handleNavClick} />

      <div className="idea-header">
        <div className="section__container">
          <h2 className="section__title">Idea Forge</h2>
          <p className="section__intro">
            IdeaForge is a leading Indian company specializing in the design and manufacturing of unmanned aerial vehicles (UAVs).
          </p>
        </div>
      </div>
      <div className="esri_content_bg">
        <FeatureSection
          title="About Idea Forge"
          text="ideaForge is a vertically integrated company with an in-house product development center, enabling the complete design, engineering, and manufacturing of indigenous unmanned aerial vehicles (UAVs). As a pioneer and market leader in India’s Unmanned Aircraft Systems sector, our UAVs are equipped with industry-leading specifications and advanced capabilities."
          imgSrc="/ideaforge1.jpg"
          imgAlt="Spatial Analytics"
        />
        <section className="esri-about-section">
          <div className="section__container esri-about-container">
            <div className="esri-about-text">
              <h2>Q6 V2 GEO</h2>
              <p>
                Built for professionals who rely on precision, it’s designed to work where the job gets tough — in remote hills, crowded cities, or long stretches of infrastructure. Whether you're running a LiDAR survey in rough landscapes or mapping dense urban grids, the Q6 V2 GEO is made to adapt. With flexible payloads, long flight times, and survey-grade accuracy, it’s not just about flying — it’s about getting the data you need, the way you need it. When you're up against tight timelines and challenging sites, it delivers the data you need — reliably, consistently, and without fuss.
              </p>
              <br></br>
            </div>
            <div className="esri-about-image">
              <img src="products/IDAFORGE/Q6V2 GEO.png" alt="ESRI Logo" />
            </div>
          </div>
        </section>
        <FeatureSection
          title="Q6 V2 UAV"
          text="Q6 V2 is our small category UAV and can be used for surveying and mapping. Its quadcopter design and high area coverage enable it to complete large-scale mapping projects quicker than our other UAVs."
          imgSrc="products/IDAFORGE/Q6V2 UAV.png"
          imgAlt="Spatial Analytics"
        />

        <FeatureSection
          title="NETRA 5"
          text="NETRA 5 redefines resilience in a world where missions face constant threats. Engineered to counter jamming, interference, and signal loss, it excels where others falter. When the mission matters most, NETRA 5 is your trusted partner, breaking barriers, overcoming the unpredictable, and achieving the extraordinary in the face of evolving challenges."
          imgSrc="products/IDAFORGE/NETRA5 UAV.png"
          imgAlt="Field Operations"
          reverse
        />

        <FeatureSection
          title="SWITCH UAV"
          text="SWITCH UAV is a fixed wing and VTOL hybrid UAV. SWITCH UAV features advanced flight time, higher safety and simple operation with additional fail-safe redundancies. It is used for long range, high endurance, high altitude last mile surveillance and security operations."
          imgSrc="products/IDAFORGE/SWITCH UAV.png"
          imgAlt="Mapping"
        />

        <FeatureSection
          title="ZOLT UAV"
          text="3ZOLT was built for this reality—a next-generation tactical UAV engineered to dominate across borders, battlefields, and disaster zones. Its where unmatched endurance meets mission-ready adaptability, all wrapped in a rugged, battle-proven design."
          imgSrc="products/IDAFORGE/ZOLT UAV.png"
          imgAlt="3D GIS"
          reverse
        />
      </div>
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'software-products', title: 'ESRI Software', icon: '/esri-logo.jpg', bgClass: 'esri-quick-bg' },
          { id: 'heremaps', title: 'Here Maps', icon: '/here.jpg', bgClass: 'here-quick-bg' },
          { id: 'maps-data-products', title: 'Planet Satellite', icon: '/planet.jpg', bgClass: 'planet-quick-bg' }
        ]}
      />
    </div>
  );
}

export default HardwareProductsPage;
